const generateLabelToPayeeText = (label?: string | null, payee?: string | null) =>
  `${label || ''} ${payee ? ` to ${payee}` : ''}`;

export default generateLabelToPayeeText;
